
$(document).on('click','.custom-plan[plan-type="one-time"]',function(){
    $('#selling_plan_id').val(' ');
})
 
 
 $(document).on("click",".plus_quantity",function() {  
    var productId = $(this).parents('.product_qty').attr('data-id');
    var qtyminus = $(this).prev().text();
    var totalqty = parseInt(qtyminus) + 1;
    var qty = $(this).parents('.product_qty').find('.main_value').text(totalqty); 
   
   var variantValue = $(this).attr('data-variant');
   var variantName = $(this).attr('variant-name');  
   var variantpropertyVal =  totalqty + variantName;

   if(variantName == "H"){
    $('.pad1').val(totalqty);
  }else if(variantName == "M"){
     $('.pad2').val(totalqty);
  }else if(variantName == "L"){
    $('.pad3').val(totalqty); 
  }
$('.product_info_pad[data-val="'+variantValue+'"]').attr('value',variantpropertyVal)
  
       var totalSum = 0;             
          $('.main_value').each(function(){          
           var mainPrice = $(this).text();
            totalSum += parseFloat(mainPrice);           
          });    
   var product_remain_value = 12 - totalSum;
   
    // $('.add_more_pads').text(totalSum)
    $('.add_more_pads').text(product_remain_value)
   if(totalSum == 12){
     $('.plus_quantity').attr('disabled',true);
      $('.add_pads').hide();
   }else{
     $('.add_pads').show();
     $('.plus_quantity').attr('disabled',false);
   }
   $('.total_quantity_value').text(totalSum);
   
  
  });
  
  $(document).on("click",".minus_quantity",function() {     
    var productId = $(this).parents('.product_qty').attr('data-id');
    var qtyminus = $(this).next().text();
    var totalqty = parseInt(qtyminus) - 1;
      if (totalqty < 0){ } 
      else{
    var qty = $(this).parents('.product_qty').find('.main_value').text(totalqty);
        } 
       var variantValue = $(this).attr('data-variant');
   var variantName = $(this).attr('variant-name');  
   var variantpropertyVal =  totalqty + variantName;
   if(variantName == "H"){
    $('.pad1').val(totalqty);
  }else if(variantName == "M"){
     $('.pad2').val(totalqty);
  }else if(variantName == "L"){
    $('.pad3').val(totalqty); 
  }
$('.product_info_pad[data-val="'+variantValue+'"]').attr('value',variantpropertyVal)
    var totalSum = 0;             
          $('.main_value').each(function(){          
           var mainPrice = $(this).text();           
            totalSum += parseFloat(mainPrice);           
          });

      var product_remain_value = 12 - totalSum;
    $('.add_more_pads').text(product_remain_value)
    // $('.add_more_pads').text(totalSum)
    
    if(totalSum == 12){
     $('.plus_quantity').attr('disabled',true);
      $('.add_pads').hide();
   }else{
     $('.plus_quantity').attr('disabled',false);
      $('.add_pads').show();
   }
     $('.total_quantity_value').text(totalSum);
    
    });

function formatMoney(amount, currency) {
  var format = '{{amount_no_decimals}}';
  var moneyFormat = currency.replace('{{amount_no_decimals}}', amount.toFixed(2));
  return moneyFormat;
}

var amounts = [];
$('.recurpay__plan').each(function(index) {
    var moneyText = $(this).find('.money').text();
    var amount = parseInt(moneyText.replace(/[^0-9]/g, '')); 
    amounts.push(amount);
    window['amount' + (index + 1)] = amount;
});


    // $('.input-label-wrapper').on('click', function () {

    //     let selectedWidget = $('.recurpay__widget_container.recurpay__widget_container--selected');
    //     let selectedType = selectedWidget.attr('data-type');

    //     if (selectedType === "subscription-purchase") {
    //         $('.recurpay__group_content_wrapper').css('display', 'block');
    //     } else {
    //         $('.recurpay__group_content_wrapper').css('display', 'none');
    //     }


    //     $('.input-label-wrapper').removeClass('selected-qnty-box');
    //     $(this).addClass('selected-qnty-box');

    //     $('.input-label-wrapper input').prop('checked', false);
    //     $(this).find('input').prop('checked', true);

    //     var getIndex = $(this).index();

    //     $('.recurpay__plan').each(function (index) {
    //         if (typeof amounts !== "undefined" && amounts[index]) {
    //             $(this).find('.money').text(getIndex * amounts[index]);
    //         }
    //     });

    //     let main_price_container = this.querySelector(".main_price_container .boxes-price");
    //     if (!main_price_container) return;

    //     let main_price = parseFloat(main_price_container.getAttribute("data-price")) || 0;
    //     let cp_price = parseFloat(main_price_container.getAttribute("data-cprice")) || 0;
        

    //     let recurpay__group_title_one_clone = document.querySelector(".recurpay__group_title-one-clone.recurpay-cloned-offer-info .recurpay__group_subtitle");
    //     let recurpay__group_title_one_clone_text_content = recurpay__group_title_one_clone.textContent;

    //     let sellingPriceEl = document.querySelector(
    //         ".recurpay__group_selling_price.recurpay__group_discounted_price .money"
    //     );

    //     if (sellingPriceEl) {
    //         if (cp_price > 0) {
    //             sellingPriceEl.innerHTML = `
    //                 ₹${main_price.toFixed(0)} 
    //                 <span class="cp-strike" style="text-decoration: line-through; color:#888; margin-left:6px;">
    //                     ₹${cp_price.toFixed(0)}
    //                 </span>
    //             `;
    //         } else {
    //             sellingPriceEl.textContent = `₹${main_price.toFixed(0)}`;
    //         }
    //     }
    //      if (cp_price) {
    //             let newValue = (parseFloat(cp_price) - parseFloat(main_price)).toFixed(0);
    //             recurpay__group_title_one_clone.style.display = "block";
    //             // console.log("================newValue " + newValue);
    //             let updatedText = recurpay__group_title_one_clone_text_content.replace(/Rs\.\d+/, `Rs.${newValue}`);
    //             recurpay__group_title_one_clone.textContent = updatedText;
    //         } else {
    //             recurpay__group_title_one_clone.style.display = "none";
    //         }

    //     let dropdown_items = document.querySelectorAll(".dropdown-custom-frequency-item");
    //     let dropdown_selected = document.querySelector(".dropdown-custom-selected");

    //     if (!dropdown_items.length || !dropdown_selected) return;

    //     dropdown_items.forEach((item) => {

    //         let discount = parseFloat(item.getAttribute("data-plan-discount")) || 0;
    //         let finalPrice = main_price - (main_price * discount) / 100;

    //         let priceSpan = item.querySelector("span:last-of-type");

    //         if (!priceSpan) {
    //             priceSpan = document.createElement("span");
    //             item.appendChild(priceSpan);
    //         }

    //         priceSpan.textContent = "₹" + finalPrice.toFixed(0);
    //     });

    //     dropdown_items.forEach(item => item.classList.remove("active"));
    // if (selectedType === "subscription-purchase") {
    //     if (dropdown_items.length > 0) {
    //       dropdown_items.forEach(item => item.classList.remove("active"));
    //       dropdown_items[0].classList.add("active");
    //       dropdown_items[0].click();
    //   }
    // }

    //     let activeItem = document.querySelector(".dropdown-custom-frequency-item.active");
    //     if (!activeItem) activeItem = dropdown_items[0];

    //     let activePriceSpan = activeItem.querySelector("span:last-of-type");
    //     let activePrice = activePriceSpan ? activePriceSpan.textContent : "₹0";

    //     let dropdownPriceSpan = dropdown_selected.querySelector("span:last-of-type");

    //     if (!dropdownPriceSpan) {
    //         dropdownPriceSpan = document.createElement("span");
    //         dropdown_selected.appendChild(dropdownPriceSpan);
    //     }

    //     dropdownPriceSpan.textContent = activePrice;


    //     let offerContainer = document.querySelector(".offer-price-container");
    //     let offerBadge = document.querySelector(".offer-price-badge");

    //     if (offerContainer) {

    //         let numericActivePrice = parseFloat(activePrice.replace("₹", "")) || 0;
    //         let minusBoth = cp_price - numericActivePrice;

    //         if (minusBoth > 0) {
    //             offerContainer.textContent = "₹" + minusBoth.toFixed(0);
    //             if (offerBadge) offerBadge.style.display = "block";
    //         } else {
    //             offerContainer.textContent = "";
    //             if (offerBadge) offerBadge.style.display = "none";
    //         }
    //     }

    // });

    
$('.input-label-wrapper').on('click', function () {
    let selectedWidget = $('.recurpay__widget_container.recurpay__widget_container--selected');
        let selectedType = selectedWidget.attr('data-type');

        if (selectedType === "subscription-purchase") {
            $('.recurpay__group_content_wrapper').css('display', 'block');
        } else {
            $('.recurpay__group_content_wrapper').css('display', 'none');
        }
    $('.input-label-wrapper').removeClass('selected-qnty-box');
    $(this).addClass('selected-qnty-box');
    $('.input-label-wrapper input').prop('checked', false);
    $(this).find('input').prop('checked', true);
    var getIndex = $(this).index();
    $('.recurpay__plan').each(function (index) {
        if (typeof amounts !== "undefined" && amounts[index]) {
            $(this).find('.money').text(getIndex * amounts[index]);
        }
    });
    let main_price_container = this.querySelector(".main_price_container .boxes-price");
    if (!main_price_container) return;

    let main_price = parseFloat(main_price_container.getAttribute("data-price")) || 0;
    let cp_price = parseFloat(main_price_container.getAttribute("data-cprice")) || 0;

    if ($('.recurpay__group_title-one-clone').length === 0) {
        // YAHAN PEHLA WALA LOGIC
        let recurpay__group_selling_price_change = document.querySelector(
            ".recurpay__group_selling_price.recurpay__group_discounted_price .money"
        );

        if (recurpay__group_selling_price_change) {
            if (cp_price > 0) {
                recurpay__group_selling_price_change.innerHTML = `
                    ₹${main_price.toFixed(0)} 
                    <span class="cp-strike" style="text-decoration: line-through; color:#888; margin-left:6px;">
                        ₹${cp_price.toFixed(0)}
                    </span>
                `;
            } else {
                recurpay__group_selling_price_change.textContent = `₹${main_price.toFixed(0)}`;
            }
        }

    } else {
        // YAHAN DUSRA WALA LOGIC
        let recurpay__group_title_one_clone = document.querySelector(".recurpay__group_title-one-clone.recurpay-cloned-offer-info .recurpay__group_subtitle");
        if (recurpay__group_title_one_clone) {
            let newValue = (cp_price - main_price).toFixed(0);
            if (cp_price > 0) {
                recurpay__group_title_one_clone.style.display = "block";
                let updatedText = recurpay__group_title_one_clone.textContent.replace(/Rs\.\d+/, `Rs.${newValue}`);
                recurpay__group_title_one_clone.textContent = updatedText;
            } else {
                recurpay__group_title_one_clone.style.display = "none";
            }
        }

        let sellingPriceEl = document.querySelector(".recurpay__group_selling_price.recurpay__group_discounted_price .money");
        if (sellingPriceEl) {
            if (cp_price > 0) {
                sellingPriceEl.innerHTML = `
                    ₹${main_price.toFixed(0)} 
                    <span class="cp-strike" style="text-decoration: line-through; color:#888; margin-left:6px;">
                        ₹${cp_price.toFixed(0)}
                    </span>
                `;
            } else {
                sellingPriceEl.textContent = `₹${main_price.toFixed(0)}`;
            }
        }
    }
    let dropdown_items = document.querySelectorAll(".dropdown-custom-frequency-item");
    let dropdown_selected = document.querySelector(".dropdown-custom-selected");
    if (!dropdown_items.length || !dropdown_selected) return;
    dropdown_items.forEach((item, index) => {
        let discount = parseFloat(item.getAttribute("data-plan-discount")) || 0;
        let finalPrice = main_price - (main_price * discount) / 100;
        let priceSpan = item.querySelector("span:last-of-type");
        if (!priceSpan) {
            priceSpan = document.createElement("span");
            item.appendChild(priceSpan);
        }
        priceSpan.textContent = "₹"+ finalPrice.toFixed(0);
        // console.log("Updated item", index, "Price:", finalPrice);
    });
    //  if (dropdown_items.length > 0) {
    //     dropdown_items.forEach(item => item.classList.remove("active"));
    //     dropdown_items[0].classList.add("active");
    //     dropdown_items[0].click(); // auto trigger first li
    // }
    if (selectedType === "subscription-purchase") {
        if (dropdown_items.length > 0) {
          dropdown_items.forEach(item => item.classList.remove("active"));
          dropdown_items[0].classList.add("active");
          dropdown_items[0].click();
      }
    }
    let activeItem = document.querySelector(".dropdown-custom-frequency-item.active");
    if (!activeItem) {
        activeItem = dropdown_items[0];
    }
    let activePriceSpan = activeItem.querySelector("span:last-of-type");
    let activePrice = activePriceSpan ? activePriceSpan.textContent : "0.00";
    let dropdownPriceSpan = dropdown_selected.querySelector("span:last-of-type");
    if (!dropdownPriceSpan) {
        dropdownPriceSpan = document.createElement("span");
        dropdown_selected.appendChild(dropdownPriceSpan);
    }
    dropdownPriceSpan.textContent = activePrice;
    let cstm_remove_ico = activePrice.replace("₹", "");
    // console.log("---cstm_remove_ico---", cstm_remove_ico);
    // console.log("Dropdown selected updated:", activePrice);
    let offerContainer = document.querySelector(".offer-price-container");
    let offerBadge     = document.querySelector(".offer-price-badge");
    if (offerContainer) {
        let minusBoth = parseFloat(cp_price) - parseFloat(cstm_remove_ico);
        offerContainer.textContent = minusBoth > 0 ? "₹" + minusBoth.toFixed(0) : "";
        if (offerBadge) {
            offerBadge.style.display = minusBoth > 0 ? "block" : "none"; 
        }
}

});

  $("input[name='assortment']:first").addClass('selected-qnty-box');
  $("input[name='assortment']").click(function(){

 var checkedRadio = document.querySelector('.custom-plan-radio:checked');

  $("input[name='assortment']").removeClass('selected-qnty-box');
  $(this).addClass('selected-qnty-box');
  var dataval = parseInt($(this).val());  
   $('.quantity__input').val(dataval)
  var mainrpice = parseFloat($('.product--thumbnail_slider .price__container span.price-item.price-item--sale.price-item--last').attr('data-p'));
  if($('.sls-select-container .input-wrapper input:checked').length >0){
    var mainrpice = parseFloat($('.sls-select-container .input-wrapper.checked .price_money').attr('data-price'));
  }

  var recurprice = $('.recurpay__plan.selected-box .money').text();

   var CompAttr = parseFloat($('.product--thumbnail_slider .price__container s.price-item.price-item--regular').attr('data-cp'));

   if(recurprice != " "){
    var calmainPrice = recurprice;
   } else{
      var calmainPrice = dataval*mainrpice;
   }
 var calmainPrice2 = dataval*mainrpice;
 $('.custom-price-wrapper .custom-price').text(calmainPrice2);
   var calcompareprice = CompAttr*dataval;
   var totalcompPrice = formatMoney(calcompareprice, "Rs. {{amount_no_decimals}}");  
   var datacompare = totalcompPrice.replace('.00',' ').replace('Rs.','₹');
  var savePrice = calcompareprice-calmainPrice;
  var totalSavePrice = formatMoney(savePrice, "Rs. {{amount_no_decimals}}"); 
  $('.totl_money_save').text(totalSavePrice)
   if (checkedRadio) {
  if (checkedRadio.id === 'radio1') {
   $('.product--thumbnail_slider .price__container span.price-item.price-item--sale.price-item--last').html('₹'+calmainPrice2);
   
setTimeout(function(){


  let priceText = $('.price_cart s.price-item.price-item--regular').text();
let numericPrice = parseInt(priceText.replace(/[^0-9]/g, ''));
    var exclusive_price = numericPrice - calmainPrice2;
    // $('.inclusive-price').text(exclusive_price)
    },500)
   


  } else if (checkedRadio.id === 'radio2') {
  $('.product--thumbnail_slider .price__container span.price-item.price-item--sale.price-item--last').html('₹'+recurprice); 

setTimeout(function(){
  let priceText = $('.price_cart s.price-item.price-item--regular').text();
let numericPrice = parseInt(priceText.replace(/[^0-9]/g, ''));
    var exclusive_price = numericPrice - recurprice;
    // $('.inclusive-price').text(exclusive_price)
     },500)
  }
} 
  
  $('.product--thumbnail_slider .price__container s.price-item.price-item--regular').text(datacompare);
  $('.selling-plan-group-options-name-select .price_money').each(function(){
    var subPrice=parseFloat($(this).attr('data-price'));
    subPrice = subPrice*dataval
   // $('p',this).text('₹'+subPrice.toFixed(2));
    var savePrice= $(this).parents('.input-wrapper').find('.save-price');
    if(savePrice != undefined){
      var savePrice= savePrice.attr('data-price');
    savePrice = savePrice*dataval;
    //  $(this).parents('.input-wrapper').find('.save-price .saveP').text(savePrice.toFixed(2));
    }
  });
  var salePrice= $(this).parents('.input-label-wrapper').find('.main_price_container .price-item--sale').text();

  var salePricewithoutCur= $(this).parents('.input-label-wrapper').find('.main_price_container .price-item--sale').attr('data-price');
  $('.sls-selling-plan-group-first-line.one-time-purchase .price_money p').text(salePrice);
       $('.sls-selling-plan-group-first-line.one-time-purchase .price_money').attr('data-price',salePricewithoutCur);
  $(".recurpay__group_price_wrapper .recurpay__group_selling_price .money").text(salePrice).toFixed(0);
});
function updateCartBubble() {
  let cartCount = null;
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      cartCount = cart.item_count;
      // console.log("cartCount"+cartCount);
 
      const cartBubble = document.querySelector('.cart-count-bubble');
 
      if (cartCount > 0) {
        cartBubble.textContent = cartCount;
        cartBubble.classList.remove('hide');
      } else {
        cartBubble.classList.add('hide');
      }
    })
    .catch(error => console.error('Cart update error:', error));
}
$(document).on("click", ".customize_button", function(e) {
  e.preventDefault();
  // debugger
  var newIndex = $('.recurpay__plan.selected-box').index();  
  var sellingPlanId = $('.cstm-selling-plan').eq(newIndex).text();
  var planName = $('.recurpay__plan.selected-box .recurpay__plan--input').attr('data-plan-name');
  var planId = $('.recurpay__plan.selected-box').attr('plan-id');
  var getQuantity = parseInt($('.selected-qnty-box').val(), 10) || 0;
  var variantId = $('.product_qty:first').attr('data-id');

  var heavy = parseInt($('.main_value').eq(0).text());
  var medium = parseInt($('.main_value').eq(1).text());
  var light = parseInt($('.main_value').eq(2).text());


// console.table(newIndex,sellingPlanId,getQuantity,variantId)



  var totalSum = 0;
  $('.main_value').each(function() {
    var mainPrice = parseFloat($(this).text());
    totalSum += isNaN(mainPrice) ? 0 : mainPrice;
  });

  if(totalSum == 12) {
    var checkedRadio = document.querySelector('.recurpay__widget_container--selected .recurpay__onetime_radio:checked');
      if (checkedRadio) {
        if (checkedRadio) {
            var packofoption = parseInt($('input[name="assortment"]:checked').val());
  if(packofoption == 2){
var variantId = '42792403534018';
  }
  else if(packofoption == 3){
var variantId = '42792403566786';
  }
       $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
               "Heavy (XXL)": heavy,
                  "Medium (XL)": medium,
                     "Light (L)": light
          }
        }]
      }),
      contentType: 'application/json',
      dataType: 'json',
      success: function(response) {
         setTimeout(function(){
        updateCartBubble();
        $('cart-drawer').removeClass('is-empty');
        $('cart-drawer').addClass('active');
        $('cart-drawer').load(window.location.href + ' #CartDrawer');
          
         },500)
      },
      error: function(xhr) {
        // console.log('Error adding to cart:', xhr.responseText);
      }
    });
        } 
        else if (checkedRadio.id === 'radio2') {
  var sellingPlanId = $('.cstm-selling-plan').eq(newIndex).text();
  var getQuantity = parseInt($('.selected-qnty-box').val(), 10) || 0;
  
  var packofoption = parseInt($('input[name="assortment"]:checked').val());
  if(packofoption == 2){
var variantId = '42792403534018';
  }
  else if(packofoption == 3){
var variantId = '42792403566786';
  }
  else{
var variantId = $('.product_qty:first').attr('data-id');
  }
  var heavy = parseInt($('.main_value').eq(0).text());
  var medium = parseInt($('.main_value').eq(1).text());
  var light = parseInt($('.main_value').eq(2).text());
  var plandiscount = parseInt($('input[name="recurpay-input"]:checked').data('plan-discount'));
  
   $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          selling_plan: parseInt(sellingPlanId),
          properties: {
            "Heavy (XXL)": heavy,
            "Medium (XL)": medium,
            "Light (L)": light,
            "sellingId": sellingPlanId.toString(),
            "Plan": planName.toString(),
            "PlanId": planId,
            "_discount":plandiscount,
          }
        }]
      }),
      contentType: 'application/json',
      dataType: 'json',
      success: function(response) {
      setTimeout(function(){         
         
          $('cart-drawer').removeClass('is-empty');
          $('cart-drawer').addClass('active');
             $('cart-drawer').load(window.location.href + ' #CartDrawer');
          
         },500)
        
      },
      error: function(xhr) {
        console.log('Error adding to cart:', xhr.responseText);
      }
    });
    // fetch("https://deyga.recurpay.com/api/storefront/v2/checkout", {

  
    //   method: "POST",
    //   headers: {
    //     "accept": "application/json",
    //     "content-type": "application/json"
    //   },
    //   body: JSON.stringify({
    //     "checkout": {
    //       "customer_id": "guest",
    //       "line_items": [
    //         {
    //           "variant_id": variantId,
    //           "quantity": getQuantity,
    //           "properties": [
    //             {"name": "_Plan","value": planName.toString() },
    //             {"name": "_PlanId","value": sellingPlanId.toString() },
    //             { "name": "Heavy (XL)", "value": heavy.toString() },
    //             { "name": "Medium (L)", "value": medium.toString() },
    //             { "name": "Light (S)", "value": light.toString() }
    //           ],
    //           "plan": {
    //             "id": planId
    //           }
              
    //         }
    //       ],
    //       "shipping_address": {
    //           "country": "India"
    //         }
    //     }
    //   })
    // })
    //   .then(response => response.json())
    //  .then(data => {
    
    //     if (data.checkout && data.checkout.url) {
    //      // console.log(data.checkout.url);
    //      window.location.href = data.checkout.url;
    //     } else {
    //       console.error("Checkout URL not found in response:", data);
    //     }
    //   })
    //   .catch(error => console.error("Error:", error));



   
        }
      } 
    
  } else {
    alert("Please select minimum 12 quantities");
  }
});

function updatePrices() {
  // Step 1: Get selected assortment price
  const $checkedAssortment = $('input[name="assortment"]:checked');
  const $wrapper = $checkedAssortment.closest('.input-label-wrapper');
  const basePrice = parseFloat($wrapper.find('span.boxes-price').attr('data-price')) || 0;
  const basecPrice = parseFloat($wrapper.find('span.boxes-price').attr('data-cprice')) || 0;

  if (basePrice === 0) return; // Skip if price not found

  // Step 2: Update One-Time Plan Price
  $('.custom-plan[plan-type="one-time"] .custom-price-wrapper .custom-price')
    .attr('data-price', basePrice)
    .text(basePrice);

  // Step 3: Update each Subscription Plan Price
  $('.recurpay__plans .recurpay__plan').each(function () {
    const $plan = $(this);
    const $input = $plan.find('input[name="recurpay-input"]');
    const discountPercent = parseFloat($input.data('plan-discount')) || 0;

    let planFinalPrice = basePrice;

    if (discountPercent > 0) {
      planFinalPrice = basePrice - (basePrice * discountPercent / 100);
    }

    $plan.find('.price_wrappper span.money').text(`${Math.round(planFinalPrice)}`);
  });

  // Step 4: Global "You Save" Section
  const $selectedPlanInput = $('input[name="recurpay-input"]:checked');
  const discountPercent = parseFloat($selectedPlanInput.data('plan-discount')) || 0;

  let finalPrice = basePrice;

  let savings = 0;

  if ($selectedPlanInput.length && discountPercent > 0) {
    savings = basePrice * discountPercent / 100;
    finalPrice = basePrice - savings;
  }
 
  if(basecPrice > 0){
    var finalsaving = (basecPrice - basePrice) + savings;
  // Update the global inclusive price (you save)
  $('.inclusive-price-outer .inclusive-price').text(`${Math.round(finalsaving)}`);
  }else{
    var finalsaving = savings;
  // Update the global inclusive price (you save)
  $('.inclusive-price-outer .inclusive-price').text(`${Math.round(savings)}`);
  }

  // Step 5: Show/hide price blocks based on savings
  if (finalsaving > 0) {
    // Show sale price, hide regular
    $('.price__container .price__sale').css('display', 'block');
    $('.price__container .price__regular').css('display', 'none');

    // Update original price inside sale block
     if(basecPrice > 0){
    $('.price__container .price__sale .price-item.price-item--regular')
      .html(`₹${Math.round(basecPrice)}`);
     }
     else{
      $('.price__container .price__sale .price-item.price-item--regular')
      .html(`₹${Math.round(basePrice)}`); 
     }
      $('.price__container .price__sale .price-item.price-item--sale.price-item--last')
      .html(`₹${Math.round(finalPrice)}`);
  } else {
    // Show regular price, hide sale block
    $('.price__container .price__regular').css('display', 'block');
    $('.price__container .price__sale').css('display', 'none');
  }

  // Step 6: Update Cart Price if custom-plan-radio is selected
  if ($('input.custom-plan-radio:checked').length > 0) {
     if(basecPrice > 0){
    $('.price_cart .price-item.price-item--regular.signle_price')
      .html(`<span class="currency_symbol">₹</span>${Math.round(basecPrice)}`);
     }
     
     else{
      $('.price_cart .price-item.price-item--regular.signle_price')
      .html(`<span class="currency_symbol">₹</span>${Math.round(basePrice)}`); 
     }
  }
}

// Step 7: Bind on ready and clicks
$(document).ready(function () {
  updatePrices(); // Run once on page load

  // These will run once each as expected
  $(document).on('click', '.recurpay__plan, .custom-plan', function () {
    updatePrices();
    setTimeout(function(){
     updatePrices();
    },200)
  });

  // This will run the function **twice** when label is clicked
  $(document).on('click', '.input-label-wrapper label', function () {
    updatePrices();
    setTimeout(function(){
     updatePrices();
    },200)
  });
});

